// extracted by mini-css-extract-plugin
export var addressFields = "_jo-0";
export var animationContainer = "_jo-1";
export var footer = "_jo-2";
export var lineItems = "_jo-3";
export var modalContent = "_jo-4";
export var orderName = "_jo-5";
export var strong = "_jo-6";
export var warning = "_jo-7";